'use client'

import { useId } from 'react'
import Form from '/react4xp/components/prototype/Form/Form'
import Input from '/react4xp/components/prototype/Form/Input'
import Button from '/react4xp/components/prototype/Button'

import type { NewsletterSignupProps } from './types'

export default function NewsletterSignup({
	heading = '',
	description = '',
	fieldLabel = 'Stay up to date',
	privacyText = 'By subscribing you agree to our Privacy Policy',
	privacyLink,
	labels = {},
	formSlot,
	onSubmit,
}: NewsletterSignupProps) {
	const emailInputId = useId()
	const { emailPlaceholder = 'Enter your email', submitLabel = 'Subscribe', requiredMessage, invalidEmailMessage } =
		labels

	const privacyNode =
		typeof privacyText === 'string' ? (
			<p
				className="body text-black-950"
				dangerouslySetInnerHTML={{
					__html: `${privacyText}${
						privacyLink?.url
							? ` <a href="${privacyLink.url}" class="button-link" target="${
									privacyLink.isExternal ? '_blank' : ''
								}" rel="${privacyLink.isExternal ? 'noopener noreferrer' : ''}">Privacy Policy</a>`
							: ''
					}`,
				}}
				suppressHydrationWarning
			/>
		) : (
			privacyText
		)

	const Root = heading ? 'section' : 'div'

	return (
		<Root className="bg-brand-50 py-14">
			<div className="container">
				<div
					className={`flex flex-col justify-end gap-8 md:gap-16 lg:flex-row lg:gap-8 ${
						heading ? 'lg:justify-between' : 'lg:justify-center'
					}`}
				>
					{heading && (
						<div className="flex flex-col gap-8 lg:max-w-108.5 lg:shrink-0">
							<h2 className="h2 max-w-108.5 text-black-950">{heading}</h2>
							{description && <p className="body text-black-950">{description}</p>}
						</div>
					)}

					<div className="my-auto flex min-w-0 max-w-200 flex-1 flex-col gap-3">
						{fieldLabel && <p className="body text-black-950">{fieldLabel}</p>}
						{formSlot ?? (
							<Form onSubmit={onSubmit} method="post" className="flex flex-col gap-3">
								<div className="flex flex-col gap-4.25 md:flex-row md:items-stretch">
									<Input
										id={emailInputId}
										name="email"
										type="email"
										ariaLabel={fieldLabel}
										placeholder={emailPlaceholder}
										required
										requiredMessage={requiredMessage}
										invalidEmailMessage={invalidEmailMessage}
										className="min-w-0 flex-1"
									/>
									<Button variant="dark" size="sm" type="submit" className="h-12.5 self-start md:h-auto md:self-stretch">
										{submitLabel}
									</Button>
								</div>
							</Form>
						)}
						{privacyNode}
					</div>
				</div>
			</div>
		</Root>
	)
}
